import(/* webpackMode: "eager" */ "/codebuild/output/src3696522302/src/src/app/global-error.tsx");
